import { render, staticRenderFns } from "./PageWarningsBanner.vue?vue&type=template&id=604b004b&scoped=true"
import script from "./PageWarningsBanner.vue?vue&type=script&lang=js"
export * from "./PageWarningsBanner.vue?vue&type=script&lang=js"
import style0 from "./PageWarningsBanner.vue?vue&type=style&index=0&id=604b004b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604b004b",
  null
  
)

export default component.exports